// extracted by css-extract-rspack-plugin
export default {"Flash":"RecentlyTouchedBranches-module__Flash__reMRu","Box":"RecentlyTouchedBranches-module__Box__d6v2n","Octicon":"RecentlyTouchedBranches-module__Octicon__PSSjA"};